var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8103_5936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 2.625C7.332 2.625 7.5 2.45738 7.5 2.25V1.875C7.5 1.25475 8.00475 0.75 8.625 0.75H12.375C12.9953 0.75 13.5 1.25475 13.5 1.875V2.25C13.5 2.45738 13.668 2.625 13.875 2.625C14.082 2.625 14.25 2.45738 14.25 2.25V1.875C14.25 0.841125 13.4089 0 12.375 0H8.625C7.59113 0 6.75 0.841125 6.75 1.875V2.25C6.75 2.45738 6.918 2.625 7.125 2.625Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.125C9.12975 10.125 8.625 10.6298 8.625 11.25V14.25C8.625 14.8703 9.12975 15.375 9.75 15.375H11.25C11.8702 15.375 12.375 14.8703 12.375 14.25V11.25C12.375 10.6298 11.8702 10.125 11.25 10.125H9.75ZM11.625 11.25V14.25C11.625 14.457 11.4566 14.625 11.25 14.625H9.75C9.54338 14.625 9.375 14.457 9.375 14.25V11.25C9.375 11.043 9.54338 10.875 9.75 10.875H11.25C11.4566 10.875 11.625 11.043 11.625 11.25Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.25H17.625C16.7977 14.25 16.125 14.9227 16.125 15.75V20.25H15.375C14.5477 20.25 13.875 20.9227 13.875 21.75V22.5C13.875 23.3273 14.5477 24 15.375 24H22.5C23.3273 24 24 23.3273 24 22.5V15.75C24 14.9227 23.3273 14.25 22.5 14.25ZM15.375 23.25C14.9614 23.25 14.625 22.9136 14.625 22.5V21.75C14.625 21.3364 14.9614 21 15.375 21H16.125V22.5C16.125 22.9136 15.7886 23.25 15.375 23.25ZM23.25 22.5C23.25 22.9136 22.9136 23.25 22.5 23.25H16.6736C16.8019 23.0291 16.875 22.773 16.875 22.5V15.75C16.875 15.3364 17.2114 15 17.625 15H22.5C22.9136 15 23.25 15.3364 23.25 15.75V22.5Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.875H18.75C18.543 16.875 18.375 17.0426 18.375 17.25C18.375 17.4574 18.543 17.625 18.75 17.625H21.75C21.957 17.625 22.125 17.4574 22.125 17.25C22.125 17.0426 21.957 16.875 21.75 16.875Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18.75H18.75C18.543 18.75 18.375 18.9176 18.375 19.125C18.375 19.3324 18.543 19.5 18.75 19.5H21.75C21.957 19.5 22.125 19.3324 22.125 19.125C22.125 18.9176 21.957 18.75 21.75 18.75Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 20.625H18.75C18.543 20.625 18.375 20.7926 18.375 21C18.375 21.2074 18.543 21.375 18.75 21.375H21.75C21.957 21.375 22.125 21.2074 22.125 21C22.125 20.7926 21.957 20.625 21.75 20.625Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.125C15.75 18.9176 15.582 18.75 15.375 18.75H1.875C1.25475 18.75 0.75 18.2452 0.75 17.625V10.119C0.859125 10.2011 0.975 10.2754 1.1025 10.3331L5.58488 12.948C5.59725 12.9551 5.61 12.9615 5.6235 12.9675C5.86163 13.0718 6.11475 13.125 6.375 13.125H7.875C8.082 13.125 8.25 12.9574 8.25 12.75C8.25 12.5426 8.082 12.375 7.875 12.375H6.375C6.22575 12.375 6.08025 12.3461 5.94263 12.2887L1.4625 9.675C1.45012 9.66787 1.437 9.6615 1.42387 9.6555C1.01475 9.47662 0.75 9.07162 0.75 8.625V4.875C0.75 4.25475 1.25475 3.75 1.875 3.75H19.125C19.7453 3.75 20.25 4.25475 20.25 4.875V8.625C20.25 9.08287 19.9766 9.49125 19.5536 9.66525C19.5416 9.6705 19.53 9.67575 19.5187 9.68175L14.6621 12.297C14.5301 12.3488 14.3914 12.375 14.25 12.375H13.125C12.918 12.375 12.75 12.5426 12.75 12.75C12.75 12.9574 12.918 13.125 13.125 13.125H14.25C14.4956 13.125 14.7356 13.0778 14.9636 12.984C14.9756 12.9791 14.9876 12.9739 14.9993 12.9675L19.8581 10.3507C20.0006 10.2904 20.13 10.2101 20.25 10.1201V13.5C20.25 13.7074 20.418 13.875 20.625 13.875C20.832 13.875 21 13.7074 21 13.5V4.875C21 3.84113 20.1589 3 19.125 3H1.875C0.841125 3 0 3.84113 0 4.875V17.625C0 18.6589 0.841125 19.5 1.875 19.5H15.375C15.582 19.5 15.75 19.3324 15.75 19.125Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8103_5936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHistory);
export default __webpack_public_path__ + "static/media/workHistory.7c4cbf47c2d57cbef9e8a1cf4ea920bd.svg";
export { ForwardRef as ReactComponent };